import { render, staticRenderFns } from "./AppBuildManagementView.vue?vue&type=template&id=cd2eb778&scoped=true&"
import script from "./AppBuildManagementView.vue?vue&type=script&lang=js&"
export * from "./AppBuildManagementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2eb778",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
